import axios from "axios";
import { apiUrl } from "../../config";
import { sendOrderToUps } from "./actions";

export const create = (data) =>
	axios
		.post(`${apiUrl}/admin/store/customers`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const update = (data) =>
	axios
		.patch(`${apiUrl}/admin/store/orders/update/status/${data._id}`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const toggle = (data) =>
	axios
		.patch(`${apiUrl}/admin/partner/toggle-status/${data._id}`)
		.then((response) => response)
		.catch((err) => err.response);

export const remove = (data) =>
	axios
		.delete(`${apiUrl}/admin/partner/delete/${data._id}`)
		.then((response) => response)
		.catch((err) => err.response);

export const getOrder = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders`)
		.then((response) => response)
		.catch((err) => err.response);

export const getMacAddressService = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders/mac-address`)
		.then((response) => response)
		.catch((err) => err.response);

export const getOrderUsingId = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders/order-details/${data.id}`)
		.then((response) => response)
		.catch((err) => err.response);

export const getInvoiceDetails = (data) => {
	if (data.orderId) {
		return axios
			.get(`${apiUrl}/admin/store/orders/invoice/${data.orderId}`)
			.then((response) => response)
			.catch((err) => err.response);
	} else {
		return axios
			.get(`${apiUrl}/admin/store/orders/get-generate-invoice/${data.id}`)
			.then((response) => response)
			.catch((err) => err.response);
	}
};

export const getUpgradeProductService = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders/product/get-upgrade-product`)
		.then((response) => response)
		.catch((err) => err.response);

export const upgradeOrderProductService = (data) =>
	axios
		.post(`${apiUrl}/admin/store/orders/product/upgrade`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const updateAddress = (data) =>
	axios
		.post(`${apiUrl}/admin/store/orders/update-user-address`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const updateBillingAddress = (data) =>
	axios
		.post(`${apiUrl}/admin/store/orders/update-order-billing-address`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const updateMethod = (data) =>
	axios
		.post(`${apiUrl}/admin/store/orders/update-order-shipping-method`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const getExportOrderCSVService = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders/export`, {
			params: data,
		})
		.then((response) => response)
		.catch((err) => err.response);

export const getOrderMerchantInvoiceService = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders/get-invoice/${data.orderId}`, {
			params: data,
		})
		.then((response) => response)
		.catch((err) => err.response);

export const changeOrderStatus = (data) =>
	axios
		.put(`${apiUrl}/admin/store/orders/${data.orderId}/status`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const updateShippingDetails = (data) =>
	axios
		.put(
			`${apiUrl}/admin/store/orders/${data.orderId}/shipping-details`,
			data
		)
		.then((response) => response)
		.catch((err) => err.response);

export const sendOrderToUpsService = (data) =>
	axios
		.post(`${apiUrl}/admin/store/orders/send-order-to-ups`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const assignOrderToUpsService = (data) =>
	axios
		.post(`${apiUrl}/admin/store/orders/assign-order-to-ups`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const getAvailableUPSOrdersService = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders/get-available-order-to-ups`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const getAvailableShippingAdminService = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders/get-available-shipping-admin`, data)
		.then((response) => response)
		.catch((err) => err.response);

export const getExportOrderInvoiceService = (data) =>
	axios
		.get(`${apiUrl}/admin/store/orders/invoice/${data.orderId}`, {
			params: data,
		})
		.then((response) => response)
		.catch((err) => err.response);
